import * as t from './actionTypes';

const initialState = { isLoading: false, shard: [] };

const shardReducer = (state = initialState, action) => {

  switch (action.type) {
    case t.SET_BUSY:
      return Object.assign({}, state, { isLoading: true });

    case t.UNSET_BUSY:
      return Object.assign({}, state, { isLoading: false });

    case t.SHARD_LOAD_SUCCESS:
      let { shard } = action;
      if (shard) {
        return ({
          ...state,
          shard: Object.keys(shard).map(id => ({
          ...shard[id],
          id,
          }))
        })
      }
      else {
        return state;
      }

    case t.SHARD_CHANGE_SUCCESS:
      //var n = action.shard;
      //var curShard = state.shard;
      //curShard = n;
      var curShard = action.shard;

      state = Object.assign({}, state, { shard: curShard });

      return state;


      case t.SHARD_CREATE_SUCCESS:
        let n = action.shard;
        shard = state.shard;
        if (!shard) shard = [];
          shard.push(n);

          state = Object.assign({}, state, { shard: shard });

          return state;

      case t.SHARD_EDIT_SUCCESS:
        n = action.shard;

        curShard = state.shard;
        for (var i = 0; i < curShard.length; i ++) {
          if (curShard[i].id === action.id) {
            curShard[i] = n;
            break;
            }
        }

        state = Object.assign({}, state, { shard: curShard });

        return state;

      case t.SHARD_DELETE_SUCCESS:
        curShard = state.shard;

        for (i = 0; i < curShard.length; i ++) {
          if (curShard[i].id === action.id) {
            curShard.splice(i, 1);
            break;
          }
        }

        state = Object.assign({}, state, { shard: curShard });

        return state;

      default:
        return state;
  }
};

export default shardReducer;
